import type { TemplateVariableType } from './types';
import { i18n } from './i18n';

export const defaultVariableName = i18n.templateVariableDefault.defaultMessage;
export const TEXT_TYPE: TemplateVariableType = 'text';
export const MULTI_LINES_TYPE: TemplateVariableType = 'textarea';
export const LIST_TYPE: TemplateVariableType = 'select';
export const ROWS_DEFAULT = 5;
export const COLUMNS_DEFAULT = 100;
